import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StateComponent } from './state.component';
import { WorkflowEffects, loadedReducer, workflowReducer } from '../public-api';

@NgModule({
  imports: [
    StoreModule.forFeature('workflow', workflowReducer),
    EffectsModule.forFeature([WorkflowEffects]),
    StoreModule.forFeature('loaded', loadedReducer),
  ],
  declarations: [StateComponent],
  exports: [StateComponent],
})
export class StateModule {}
